import { ReactElement } from 'react';
import { Container } from 'components/GridSystem';
import VehicleBadge from 'components/VehicleBadge';
import { Check } from '@styled-icons/remix-fill';
import { ArrowDropRight } from '@styled-icons/remix-line/ArrowDropRight';
import { ArrowRight } from '@styled-icons/feather/ArrowRight';

import theme from 'styles/theme';
import FormButton from 'components/Button';
import LoadingSpinner from 'components/LoadingSpinner';
import * as S from './style';

export type FloatButtonBarType = {
  img: string;
  title: string;
  referralCode?: string;
  label?: string | JSX.Element;
  value: string;
  showVehicleBadge?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  id?: string;
  isHalfPaymentActive?: boolean;
  showPaymentBadge?: boolean;
  isPayment?: boolean;
  isProcessing?: boolean;
  isSuccess?: boolean;
};

type DetailsProps = {
  mobile?: boolean;
  referralCode?: string;
  showPaymentBadge: boolean;
  isHalfPaymentActive: boolean;
};

const Details = ({
  referralCode,
  showPaymentBadge,
  isHalfPaymentActive,
}: DetailsProps) => {
  return (
    <S.Details hasCode={!!referralCode}>
      {!!referralCode && (
        <S.Code>
          <S.Label>{referralCode}</S.Label> - Code applied
        </S.Code>
      )}
      {showPaymentBadge && (
        <S.PaymentOption>
          <Check size={16} color={theme.colors.statusSuccess30} />
          {isHalfPaymentActive ? 'Half' : 'Full'} payment selected
        </S.PaymentOption>
      )}
    </S.Details>
  );
};

const FloatButtonBar = ({
  img,
  title,
  referralCode,
  label,
  value,
  disabled,
  isLoading,
  id,
  showVehicleBadge = true,
  isHalfPaymentActive = false,
  showPaymentBadge = false,
  isPayment = false,
  isProcessing,
  isSuccess,
}: FloatButtonBarType) => {
  const getIcon = () => {
    let response: ReactElement | null = null;
    if (isPayment) {
      if (!disabled) {
        response = <ArrowRight strokeWidth={2} size={26} />;
      }
      if (isSuccess) {
        response = <Check strokeWidth={2} size={26} />;
      }
      if (isLoading || isProcessing) {
        response = <LoadingSpinner />;
      }
      return (
        <>
          &nbsp;
          {response}
        </>
      );
    }
    return isLoading ? <LoadingSpinner /> : <ArrowDropRight size={18} />;
  };

  const getLabel = () => {
    if (isPayment) {
      if (isProcessing) {
        return 'Processing payment ';
      }
      if (isSuccess) {
        return 'Deal concluded!';
      }
    }
    return label || 'next';
  };
  return (
    <S.Wrapper>
      <Container>
        <S.FlexContainer>
          {showVehicleBadge && (
            <S.ShowDesktop>
              <VehicleBadge value={value} img={img} title={title} />
            </S.ShowDesktop>
          )}
          <S.ButtonContainer>
            <FormButton
              id={id}
              disabled={(!isPayment && isLoading) || disabled}
              fullWidth
              icon={<>&nbsp;{getIcon()}</>}
              type="submit"
              isProcessing={isProcessing}
              isSuccess={isSuccess}
            >
              {getLabel()}
            </FormButton>
            <S.FlexContainer>
              <Details
                referralCode={referralCode}
                showPaymentBadge={showPaymentBadge}
                isHalfPaymentActive={isHalfPaymentActive}
              />
            </S.FlexContainer>
          </S.ButtonContainer>
        </S.FlexContainer>
      </Container>
    </S.Wrapper>
  );
};

export default FloatButtonBar;
